import { __assign } from "tslib";
import React from 'react';
import { Heading, Text } from '@wix/design-system';
import { sanitizeHtml } from '../../utils/text';
export var RenderHTML = function (_a) {
    var html = _a.html, className = _a.className, dataHook = _a.dataHook, textElement = _a.textElement, headingElement = _a.headingElement, onClick = _a.onClick;
    if (textElement) {
        return (React.createElement(Text, __assign({ className: className, dangerouslySetInnerHTML: { __html: sanitizeHtml(html) }, dataHook: dataHook, "data-testid": dataHook }, (onClick ? { onClick: onClick } : {}), textElement)));
    }
    else if (headingElement) {
        return (React.createElement(Heading, __assign({ className: className, dangerouslySetInnerHTML: { __html: sanitizeHtml(html) }, dataHook: dataHook, "data-testid": dataHook }, (onClick ? { onClick: onClick } : {}), headingElement)));
    }
    else {
        return (React.createElement("div", __assign({ "data-testid": dataHook, className: className, dangerouslySetInnerHTML: { __html: sanitizeHtml(html) }, "data-hook": dataHook }, (onClick ? { onClick: onClick } : {}))));
    }
};
//# sourceMappingURL=index.js.map